

function ratingEnable() {

        var currentRating = $('#example-fontawesome-o').data('current-rating');

        $('.stars-example-fontawesome-o .current-rating')
            .find('span')
            .html(currentRating);

        $('.stars-example-fontawesome-o .clear-rating').on('click', function(event) {
            event.preventDefault();

            $('#example-fontawesome-o')
                .barrating('clear');
        });

        $('#example-fontawesome-o').barrating({
            theme: 'fontawesome-stars-o',
            showSelectedRating: true,
            initialRating: currentRating,
            fastClicks: true,
            onSelect: function(value, text) {
                if (!value) {
                    $('#example-fontawesome-o')
                        .barrating('clear');
                } else {
                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        }
                    });
                    var setupHash = $('input[id=setupHash]').val();
                    $.ajax({
                        type: 'POST',
                        cache: false,
                        dataType: 'JSON',
                        url: '/carsetup/rate',
                        data: {
                          hash: setupHash,
                          rate: value
                        },
                        success: function(data) {
                            // $('.nk-rating').html('');
                            if(data.status == 'success'){
                              $('.stars-example-fontawesome-o .your-rating')
                                  .find('span.value')
                                  .html(data.rate);
                              $('.stars-example-fontawesome-o')
                                  .find('span.msg_rate')
                                  .css({ display: "block" })
                                  .html(data.message);
                            } else {
                              $('.stars-example-fontawesome-o')
                                  .find('span.msg_rate')
                                  .css({ display: "block" })
                                  .html(data.message);
                              // console.log('Data error: '+ JSON.stringify(data));
                            }

                        },
                        error: function(data) {
                        },

                    });
                    // $('.stars-example-fontawesome-o .current-rating')
                    //     .addClass('hidden');
                }
            },
            onClear: function(value, text) {
                $('.stars-example-fontawesome-o')
                    .find('.current-rating')
                    .removeClass('hidden')
                    .end()
                    .find('.your-rating')
                    .addClass('hidden');
            }
        });

        var driverRating = $('#driver-rating').data('current-rating');

        $('#driver-rating').barrating({
            theme: 'fontawesome-stars-o',
            showSelectedRating: true,
            initialRating: driverRating,
            fastClicks: false,
            readonly: true
        });
    }

function ratingDisable() {
        $('select').barrating('destroy');
    }

$('.rating-enable').click(function(event) {
    event.preventDefault();

    ratingEnable();

    $(this).addClass('deactivated');
    $('.rating-disable').removeClass('deactivated');
});

$('.rating-disable').click(function(event) {
    event.preventDefault();

    ratingDisable();

    $(this).addClass('deactivated');
    $('.rating-enable').removeClass('deactivated');
});

ratingEnable();
